import { render } from "./ClientCajasListado.vue?vue&type=template&id=50306660"
import script from "./ClientCajasListado.vue?vue&type=script&lang=js"
export * from "./ClientCajasListado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__